
<template>
  <transition name="demo">
    <div v-show="showToast" class="toast" :class="position">
      <div class="toast_container" v-if="type=='success'">
        <!-- <div>
          <i class="iconfont icon-check icon"></i>
        </div> -->
        <div class="msg_container">{{message}}</div>
      </div>
      <div class="toast_container" v-else-if="type=='wrong'">
        <!-- <div>
          <i class="iconfont icon-warning-circle icon"></i>
        </div> -->
        <div class="msg_container">{{message}}</div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: {
    message: String,
    type: {
      validator: function(value) {
        // 值必须是这些字符串中的一个
        return ["success", "wrong", "loading"].indexOf(value) !== -1;
      },
      default: "success"
    },
    duration: {
      type: Number,
      default: 3000
    },
    position: {
      type: String,
      default: "middle"
    }
  },
  //   components:{
  //     loading10
  //   },
  data() {
    return {
      showToast: false
    };
  }
};
</script>
 
<style scoped>
.toast {
  width: 100%;
}
.toast_container {
  background: rgba(0, 0, 0, 0.7);
  border-radius: 8px;
  color: #fff;
  margin-left: 88px;
  margin-right: 88px;
  text-align: center;
  padding: 10px 0;
}
.top {
  position: fixed;
  top: 20%;
  z-index: 1000;
}
.demo-enter-active,
.demo-leave-active {
  transition: 0.3s ease-out;
}
.demo-enter {
  opacity: 0;
  transform: scale(1.2);
}
.middle {
  position: fixed;
  top: 60%;
   z-index: 1000;
}
.middles{
  position: fixed;
  top: 50%;
  z-index: 2002;
  transform: rotate(90deg);
}
.bottom {
  position: fixed;
  top: 70%;
   z-index: 1000;
}
.msg_container {
  margin-left: 15px;
  margin-right: 15px;
  line-height: 22px;
  font-size: 1.25rem;
  word-wrap: break-word;
}
.icon {
  font-size: 30px;
}
</style>